import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2ProviderSupportRequests: build.mutation<
      PostV2ProviderSupportRequestsApiResponse,
      PostV2ProviderSupportRequestsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/support/requests`,
        method: "POST",
        body: queryArg.supportRequestCreate,
      }),
    }),
    getV2ProviderSupportRequestsByRequestId: build.query<
      GetV2ProviderSupportRequestsByRequestIdApiResponse,
      GetV2ProviderSupportRequestsByRequestIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/support/requests/${queryArg.requestId}`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2ProviderSupportRequestsApiResponse =
  /** status 200 OK */ SupportRequestResponse;
export type PostV2ProviderSupportRequestsApiArg = {
  supportRequestCreate: SupportRequestCreate;
};
export type GetV2ProviderSupportRequestsByRequestIdApiResponse =
  /** status 200 OK */ SupportRequestResponse;
export type GetV2ProviderSupportRequestsByRequestIdApiArg = {
  requestId: string;
};
export type SupportRequestResponse = {
  message: string;
  reply_email: string;
  request_id: string;
  retry_allowed: boolean;
  status: "pending" | "sent" | "failed" | "unknown";
};
export type SupportRequestErrorResponse = {
  error_code: string;
  message: string;
};
export type SupportScreenshot = {
  content_type: "image/png" | "image/jpeg" | "image/webp";
  data_base64: string;
  filename: string;
};
export type SupportRequestCreate = {
  attachment?: SupportScreenshot | null;
  message: string;
  page_area?: "schedule" | "templates" | "patients" | "billing" | "other";
  request_id: string;
  subject?: string;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
